import AppHeader from "@/components/AppHeader";

export default {
  name: "master-department-edit",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getDepartment();
  },
  data() {
    return {
      department: {
        company_id: "",
        name: "",
        name_kana: "",
        is_attendance_auto: ""
      },
      companies: "",
      getCompanisEnd: false,
      getDepartmentEnd: false
    };
  },
  computed: {
    companyName() {
      let findCompany = this.companies.find(
        company => company.id == this.department.company_id
      );
      return findCompany.name;
    }
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getDepartment() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_DEPARTMENT", {
          id: this.$route.params.department_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.department.company_id = res.department.company_id;
      this.department.name = res.department.name;
      this.department.name_kana = res.department.name_kana;
      this.department.is_attendance_auto = res.department.is_attendance_auto;
      this.getDepartmentEnd = true;
    },
    async editDepartment() {
      let data = this.department;
      let res = await this.$store
        .dispatch("EDIT_DEPARTMENT", {
          id: this.$route.params.department_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_department" });
      }
    },
    goMasterDepartment() {
      this.$router.push({ path: "/master_department" });
    }
  }
};
